/**
 * Phase 18.17 Batch 5 — Extra page CMS hook.
 *
 * Hydrates {sections: {page_banner, intro, cta_band}} from
 *   GET /api/website/extra-pages/{slug}
 * Falls back to the production-safe defaults baked into the page
 * banner wrapper so the UI never goes blank on a cold start.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function useExtraPageCms(slug, fallback) {
  const [data, setData] = useState(fallback || null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${BACKEND_URL}/api/website/extra-pages/${slug}`, { timeout: 8000 })
      .then((res) => {
        if (cancelled) return;
        const sections = res?.data?.sections;
        if (sections && typeof sections === "object") {
          setData((prev) => ({
            page_banner: {
              ...(fallback?.page_banner || prev?.page_banner || {}),
              ...(sections.page_banner || {}),
              badges: Array.isArray(sections.page_banner?.badges)
                ? sections.page_banner.badges
                : (fallback?.page_banner?.badges || prev?.page_banner?.badges || []),
            },
            intro: {
              ...(fallback?.intro || prev?.intro || {}),
              ...(sections.intro || {}),
            },
            cta_band: {
              ...(fallback?.cta_band || prev?.cta_band || {}),
              ...(sections.cta_band || {}),
            },
          }));
        }
      })
      .catch(() => { /* keep fallback */ })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return { data: data || fallback, loaded };
}
